export default __webpack_public_path__ + "static/media/heart.1ea14181.svg";